import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  attendanceRecords: [],
  pagination: {},
  selectedAttendanceRecord: null,
};

const attendanceRecordsSlice = createSlice({
  name: "attendanceRecords",
  initialState,
  reducers: {
    // Get Attendance Records
    getAttendanceRecordsStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    getAttendanceRecordsSuccess: (state, action) => {
      state.loading = false;
      state.attendanceRecords = action.payload.data;
      state.pagination = action.payload.pagination;
      state.error = null;
    },

    getAttendanceRecordsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Set Selected Attendance Record
    setSelectedAttendanceRecord: (state, action) => {
      state.selectedAttendanceRecord = action.payload;
    },

    // Update Attendance Record Approval Status locally
    updateAttendanceApprovalStatus: (state, action) => {
      const { id, approval_status } = action.payload;
      state.attendanceRecords = state.attendanceRecords.map((rec) =>
        rec.id === id ? { ...rec, approval_status } : rec
      );
    },

    // Clear Error
    clearAttendanceRecordsError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getAttendanceRecordsStart,
  getAttendanceRecordsSuccess,
  getAttendanceRecordsFailure,
  setSelectedAttendanceRecord,
  updateAttendanceApprovalStatus,
  clearAttendanceRecordsError,
} = attendanceRecordsSlice.actions;

export default attendanceRecordsSlice.reducer;
